import { PanelFooter, PanelHeader, PanelTitle } from 'components/secondaryMarket/shared/status/Panel';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import type { SecondaryMarketPostEventTabType } from '../../../../../state/workspaces/model';

export type PendingAmendSidePanelProps = Readonly<{
  tabType: SecondaryMarketPostEventTabType;
}>;
export const PendingAmendSidePanel: FC<PendingAmendSidePanelProps> = () => {
  const { formatMessage } = useIntl();
  return (
    <div className="d-flex flex-column h-100 justify-content-start overflow-y-auto">
      <PanelHeader color="warning" discreet>
        <PanelTitle className="flex-grow-1">
          {formatMessage({ id: 'secondaryMarket.sidePanel.label.applyPending' })}
        </PanelTitle>
      </PanelHeader>
      <PanelFooter
        color="warning"
        discreet
        statusKey="secondaryMarket.sidePanel.label.applyPendingStatus"
        icon="hourglass_empty"
      />
    </div>
  );
};
PendingAmendSidePanel.displayName = 'PendingAmendSidePanel';
